"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uiMoney = _interopRequireDefault(require("ui-money"));
var _button = _interopRequireDefault(require("./button"));
var _panels = _interopRequireDefault(require("./panels"));
var Shapes = _interopRequireWildcard(require("./shapes"));
var _productTypes = _interopRequireDefault(require("../../utils/product-types"));
var _excluded = ["term", "intRate", "amount", "totalCost", "monthlyPayment", "minimumAmount", "maximumAmount"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var toDollar = function toDollar(number) {
  return new _uiMoney.default(number, 'USD').format(0);
};
var formatOffers = function formatOffers(offers) {
  return offers.map(function (_ref) {
    var term = _ref.term,
      intRate = _ref.intRate,
      amount = _ref.amount,
      totalCost = _ref.totalCost,
      monthlyPayment = _ref.monthlyPayment,
      minimumAmount = _ref.minimumAmount,
      maximumAmount = _ref.maximumAmount,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    return _objectSpread({
      productTerm: term,
      loanAmount: toDollar(amount),
      totalCost: toDollar(totalCost),
      minMonthlyPayments: toDollar(monthlyPayment),
      minimumApr: "".concat(intRate, "%"),
      minimumAmount: toDollar(minimumAmount),
      maximumAmount: toDollar(maximumAmount)
    }, rest);
  });
};
var ProductPanel = function ProductPanel(props) {
  var offers = formatOffers(props.offers);
  var selectedOfferId = props.selectedOfferId,
    onSelection = props.onSelection,
    onConfirmation = props.onConfirmation,
    constants = props.constants,
    productType = props.productType,
    isFormValid = props.isFormValid,
    subMarket = props.subMarket;
  var ilOffers = offers.filter(function (_ref2) {
    var product = _ref2.product;
    return product === _productTypes.default.IL;
  }) || [];
  var prpOffers = offers.filter(function (_ref3) {
    var product = _ref3.product;
    return product === _productTypes.default.PRP;
  }) || [];
  var ifOffers = offers.filter(function (_ref4) {
    var product = _ref4.product;
    return product === _productTypes.default.IF;
  }) || [];
  var lcfrpOffers = offers.filter(function (_ref5) {
    var product = _ref5.product;
    return product === _productTypes.default.LCFRP;
  }) || [];
  var lctniOffers = offers.filter(function (_ref6) {
    var product = _ref6.product;
    return product === _productTypes.default.LCTNI;
  }) || [];
  var colSize = ifOffers.length && prpOffers.length || lcfrpOffers.length && lctniOffers.length ? 6 : 12;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "offers-content"
  }, offers && offers.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, ['IF', 'PRP'].includes(productType) && /*#__PURE__*/_react.default.createElement("div", {
    className: "ads-offers col-md-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12 product-revolving-container"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "product-revolving-container__text"
  }, "Revolving lines of credit"), /*#__PURE__*/_react.default.createElement("span", {
    className: "product-revolving-container__type"
  }, " with Comenity Capital Bank")), /*#__PURE__*/_react.default.createElement(_panels.default, {
    constants: constants,
    offers: ifOffers,
    colSize: colSize,
    index: 2,
    monthlyIndexSup: 1,
    onChange: onSelection,
    selectedOffer: selectedOfferId,
    productType: "IF",
    subMarket: subMarket
  }), /*#__PURE__*/_react.default.createElement(_panels.default, {
    constants: constants,
    offers: prpOffers,
    colSize: colSize,
    monthlyIndexSup: 3,
    index: 4,
    onChange: onSelection,
    selectedOffer: selectedOfferId,
    productType: "PRP",
    subMarket: subMarket
  })), productType === 'IL' && /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12 il-offers"
  }, /*#__PURE__*/_react.default.createElement(_panels.default, {
    constants: constants,
    offers: ilOffers,
    colSize: colSize,
    onChange: onSelection,
    monthlyIndexSup: 2,
    selectedOffer: selectedOfferId,
    productType: "IL",
    subMarket: subMarket
  })), ['LCFRP', 'LCTNI'].includes(productType) && /*#__PURE__*/_react.default.createElement("div", {
    className: "lcb-offers col-md-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12 product-revolving-container"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "product-revolving-container__text"
  }, "Fixed Installment Loans"), /*#__PURE__*/_react.default.createElement("span", {
    className: "product-revolving-container__type"
  }, " with LendingClub Bank")), /*#__PURE__*/_react.default.createElement(_panels.default, {
    constants: constants,
    offers: lcfrpOffers,
    colSize: colSize,
    index: 1,
    onChange: onSelection,
    selectedOffer: selectedOfferId,
    productType: "LCFRP",
    subMarket: subMarket
  }), /*#__PURE__*/_react.default.createElement(_panels.default, {
    constants: constants,
    offers: lctniOffers,
    colSize: colSize,
    index: 1,
    onChange: onSelection,
    selectedOffer: selectedOfferId,
    productType: "LCTNI",
    subMarket: subMarket
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: onConfirmation,
    enabled: isFormValid
  })) : null);
};
ProductPanel.propTypes = {
  products: _propTypes.default.arrayOf(Shapes.Product),
  offers: _propTypes.default.arrayOf(_propTypes.default.object),
  selectedRadio: _propTypes.default.arrayOf(Shapes.ProductSelected),
  buttonAction: _propTypes.default.bool,
  selectedOfferId: _propTypes.default.string,
  onConfirmation: _propTypes.default.func,
  onSelection: _propTypes.default.func,
  constants: _propTypes.default.object,
  productType: _propTypes.default.string,
  isFormValid: _propTypes.default.bool,
  subMarket: _propTypes.default.string
};
ProductPanel.defaultProps = {
  offers: [],
  productType: ''
};
var _default = ProductPanel;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');